<template>
    <div class="illegalInfo">
        <h3></h3>
        <van-nav-bar
            title="广告内容监测详情"
            left-text="返回"
            left-arrow
            @click-left="$router.push('/monitor')"
        />
        <van-panel style="margin-top: unset" v-if="+queryType === 1">
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    屏体信息
                </div>
            </template>
            <van-cell title="屏体编号" :value="illegalInfo.screenId" />
            <van-cell title="屏体名称" :value="illegalInfo.screenName" />
            <van-cell title="屏体实景图">
                <template>
                    <img @click="imgPreview(illegalInfo.screen.realPictureUrl)" class="img" :src="getUrl(illegalInfo.screen.realPictureUrl)" />
                </template>
            </van-cell>
            <van-cell title="分辨率" :value="illegalInfo.screen.resolution" />
            <van-cell title="开屏时长" :value="illegalInfo.screen.turnTime" />
            <van-cell title="所在区域" :value="illegalInfo.screen.province + illegalInfo.screen.city + illegalInfo.screen.district" />
            <van-cell title="具体位置" :value="illegalInfo.screen.address" @click="viewMap(1)">
                <template #right-icon>
                    <van-icon name="location" class="location-icon" />
                </template>
            </van-cell>
        </van-panel>
        <van-panel v-if="+queryType === 1">
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    屏主信息
                </div>
            </template>
            <van-cell title="联系人">
                <template>
                    <span>
                        {{illegalInfo.screen.userName}}
                    </span>
                    <span style="color: #2f54eb" @click="tell(illegalInfo.screen.userPhone)">
                        {{ illegalInfo.screen.userPhone }}
                    </span>
                </template>
            </van-cell>
            <van-cell title="单位" :value="illegalInfo.screen.userCompanyName" />
            <van-cell title="联系地址" :value="illegalInfo.screen.userAddress" />
        </van-panel>
        <van-panel style="margin-top: unset" v-if="+queryType === 2">
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    媒体信息
                </div>
            </template>
            <van-cell title="媒体名称" :value="illegalInfo.mediaName" />
            <van-cell title="媒体类型" :value="illegalInfo.mediaType" />
            <van-cell title="所在区域" :value="illegalInfo.monitorMaterialAdVo.province + illegalInfo.monitorMaterialAdVo.city + illegalInfo.monitorMaterialAdVo.district" />
            <van-cell title="具体位置" :value="illegalInfo.monitorMaterialAdVo.address" @click="viewMap(2)">
                <template #right-icon>
                    <van-icon name="location" class="location-icon" />
                </template>
            </van-cell>
        </van-panel>
        <van-panel v-if="+queryType === 2">
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    广告主信息
                </div>
            </template>
            <van-cell title="广告主" :value="illegalInfo.contentCustomerName" />
            <van-cell title="行业" :value="illegalInfo.contentCustomerIndustry" />
            <van-cell title="公司名称" :value="illegalInfo.companyName" />
            <van-cell title="联系人" :value="illegalInfo.contactName" />
            <van-cell title="公司地址" :value="illegalInfo.companyAddress" />
        </van-panel>
        <van-panel v-if="+queryType === 1">
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    内容信息
                </div>
            </template>
            <van-cell title="广告主" :value="illegalInfo.contentCustomerName" />
            <van-cell title="行业" :value="(illegalInfo.contentCustomerMainIndustry ? illegalInfo.contentCustomerMainIndustry + '-' : '') + illegalInfo.contentCustomerIndustry" />
            <van-cell v-if="+illegalInfo.totalPlayCount > 0" title="播放次数" :value="illegalInfo.totalPlayCount + '次'" />
            <van-cell v-if="+illegalInfo.totalSecond > 0" title="播放秒数" :value="illegalInfo.totalSecond + '秒'" />
        </van-panel>
        <van-panel>
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    违法信息
                </div>
            </template>
            <van-collapse v-model="activeNames" accordion>
                <van-collapse-item :style="'text-align: left'" v-for="(item, index) in illegalInfo.keywordList" :key="index" :name="index" :is-link="false">
                    <template #value>
                        <van-button size="mini" type="info">查看详情</van-button>
                    </template>
                    <template #title>
                        <div>
                            {{ index + 1 + "、" + item.keyword.keyword }}
                            <van-tag :color="item.keyword.level === 1 ? '#fa8c16' : item.keyword.level === 2 ? '#a0d911' : item.keyword.level === 3 ? '#fa541c' : '#f5222d'">
                                {{ item.keyword.level === 1 ? "普通" : item.keyword.level === 2 ? " 重点" : item.keyword.level === 3 ? "紧急" : "特殊" }}
                            </van-tag>
                        </div>
                    </template>
                    <van-panel v-if="+queryType === 1">
                        <template #header>
                            <div class="panelTitle">
                                <div style="background: #07b50f"></div>
                                取证内容
                            </div>
                        </template>
                    </van-panel>
                    <van-panel v-if="+queryType === 1">
                        <van-cell :title="item2.content" v-for="(item2, index2) in item.contentList" :key="index2">
                            <template v-if="item2.eachSeekUrl">
                                <img @click="imgPreview(item2.eachSeekUrl)" class="img" :src="getUrl(item2.eachSeekUrl)" />
                            </template>
                        </van-cell>
                    </van-panel>
                    <van-panel v-if="+queryType === 2">
                        <template #header>
                            <div class="panelTitle">
                                <div style="background: #07b50f"></div>
                                取证内容
                            </div>
                        </template>
                        <van-cell :title="item2.content" v-for="(item2, index2) in item.contentAdList" :key="index2">
                            <template>
                                <img @click="imgPreview(item2.eachSeekUrl)" class="img" :src="getUrl(item2.eachSeekUrl)" />
                            </template>
                        </van-cell>
                    </van-panel>
                    <van-panel>
                        <template #header>
                            <div class="panelTitle">
                                <div style="background: #07b50f"></div>
                                法条罚条
                            </div>
                            <van-collapse v-model="activeNames2" class="lawPanel" accordion>
                                <van-collapse-item style="text-align: left" title="法条" name="1">
                                    <div v-for="(item, index) in item.lexiconList" :key="index">
                                        <van-cell v-if="+item.lawType === 1" :label="item.content">
                                            <template #title>
                                                <span>{{ item.name }}</span>
                                                <van-tag type="danger">{{ item.clause }}</van-tag>
                                                <van-tag color="#36cfc9" v-if="item.code">{{ item.code }}</van-tag>
                                            </template>
                                        </van-cell>
                                    </div>
                                </van-collapse-item>
                                <van-collapse-item style="text-align: left" title="罚条" name="2">
                                    <div v-for="(item, index) in item.lexiconList" :key="index">
                                        <van-cell v-if="+item.lawType === 2" :label="item.content">
                                            <template #title>
                                                <span>{{ item.name }}</span>
                                                <van-tag type="danger">{{ item.clause }}</van-tag>
                                                <van-tag color="#36cfc9" v-if="item.code">{{ item.code }}</van-tag>
                                            </template>
                                        </van-cell>
                                    </div>
                                </van-collapse-item>
                            </van-collapse>
                        </template>
                    </van-panel>
                </van-collapse-item>
            </van-collapse>
        </van-panel>
        <van-panel>
            <template #header>
                <div class="panelTitle">
                    <div></div>
                    处理信息
                </div>
            </template>
            <van-cell title="违法判别">
                <van-tag :color="illegalInfo.type === 1 ? '#389e0d' : '#f5222d'">
                    {{ illegalInfo.type === 1 ? "误判排除" : "违法线索" }}
                </van-tag>
            </van-cell>
            <van-cell title="补充说明" :label="illegalInfo.remarkContent" />
        </van-panel>
        <!-- 一键导航悬浮按钮 -->
        <div class="float-nav-btn">
            <van-button color="#1989fa" block round @click="navigate()">
                <van-icon name="location-o" />
                一键导航
            </van-button>
        </div>
    </div>
</template>

<script>
import { ImagePreview } from "vant";
import {resourceUrl} from "@/utils/base";
import { navigateToLocation } from '@/utils/wxWebview';
import { toDisplayDistrict } from '@/utils/regionData';
export default {
    data() {
        return {
            illegalId: '',          // 路由传递的ID

            illegalInfo: {
                screen: {},
                monitorMaterialAdVo: {},
            },
            activeNames: [0],
            activeNames2: "1",
            queryType: 0,
            programInfo: {},
            fileType: "",
            file: {
                data: {},
            },
        };
    },
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    created() {
        // 1. 获取路由参数
        this.getRouteParams();
        let type = this.queryType
        console.log("this.queryType",this.queryType)
        if (+type === 1) {
            let params = { illegalId: this.illegalId };
            console.log("进来了")
            this.$get("/record/messagelog/queryIllegalInfo", params)
                .then((res) => {
                    if (res.rescode === 200) {
                        this.illegalInfo = this.normalizeDistrict(res.data);
                        this.fileType = res.data.keywordList[0].contentList[0].type;
                    } else {
                        this.$toast(res.msg);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        } else if (+type === 2) {
            let params =  { illegalId: this.illegalId };
            this.$get("/record/messagelog/queryAdIllegalInfo", params)
                .then((res) => {
                    if (res.rescode === 200) {
                        this.illegalInfo = this.normalizeDistrict(res.data);
                    } else {
                        this.$toast(res.msg);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    methods: {
        // 后端区划存「岳麓区」，展示口径统一转为「湘江新区」
        normalizeDistrict(info) {
            if (!info) return info;
            if (info.screen) info.screen.district = toDisplayDistrict(info.screen.district);
            if (info.monitorMaterialAdVo) info.monitorMaterialAdVo.district = toDisplayDistrict(info.monitorMaterialAdVo.district);
            return info;
        },
        // 1. 获取路由参数（Vue 2 兼容写法）
        getRouteParams() {
            console.log("this.$route.query.illegalId",this.$route.query.illegalId)
            // 兼容两种传参方式：query/params
            this.illegalId = this.$route.query.illegalId || this.$route.params.illegalId || '';
            console.log(" this.$route.query", this.$route.query)
            this.queryType = this.$route.query.queryType || this.$route.params.queryType || 0;
        },
        viewMap(type) {
            if (type === 1) {
                const s = this.illegalInfo.screen;
                this.$router.push({
                    path: `/map`,
                    query: {
                        lng: s.longitude,
                        lat: s.latitude,
                        name: this.illegalInfo.screenName || '屏体位置',
                        address: (s.province || '') + (s.city || '') + (s.district || '') + (s.address || ''),
                    }
                });
            }
            if (type === 2) {
                const m = this.illegalInfo.monitorMaterialAdVo;
                this.$router.push({
                    path: `/map`,
                    query: {
                        lng: m.longitude,
                        lat: m.latitude,
                        name: this.illegalInfo.mediaName || '媒体位置',
                        address: (m.province || '') + (m.city || '') + (m.district || '') + (m.address || ''),
                    }
                });
            }
        },
        async navigate() {
            const type = +this.queryType;
            let lng, lat, name, address;
            if (type === 1) {
                lng = this.illegalInfo.screen.longitude;
                lat = this.illegalInfo.screen.latitude;
                name = this.illegalInfo.screenName || '屏体位置';
                address = (this.illegalInfo.screen.province || '') + (this.illegalInfo.screen.city || '') + (this.illegalInfo.screen.district || '') + (this.illegalInfo.screen.address || '');
            } else if (type === 2) {
                lng = this.illegalInfo.monitorMaterialAdVo.longitude;
                lat = this.illegalInfo.monitorMaterialAdVo.latitude;
                name = this.illegalInfo.mediaName || '媒体位置';
                address = (this.illegalInfo.monitorMaterialAdVo.province || '') + (this.illegalInfo.monitorMaterialAdVo.city || '') + (this.illegalInfo.monitorMaterialAdVo.district || '') + (this.illegalInfo.monitorMaterialAdVo.address || '');
            }
            try {
                await navigateToLocation({ lng, lat, name, address });
            } catch (e) {
                this.$toast(e.message || '导航失败');
            }
        },
        queryProgram(queryInfo) {
            this.queryProgramInfo(queryInfo.programVideoId);
        },
        queryProgramInfo(programVideoId) {
            let params = {
                programVideoId: programVideoId,
            };
            this.$get("/monitor/monitorillegalcontent/queryProgramVideo", params)
                .then((res) => {
                    if (res.rescode === 200) {
                        this.programInfo = res.data;
                    } else {
                        this.$toast(res.msg);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        tell(phoneNumber) {
            window.location.href = "tel://" + phoneNumber;
        },
        getUrl(url) {
            // 如果有多张，则取第一张
            let urls = url.split(',');
            if (urls.length > 1) {
                url = urls[0];
            }
            if (url.indexOf("http") == -1) {
                url =resourceUrl + url;
            }
            return url;
        },
        imgPreview(url) {
            // 多张
            let urls = url.split(',');
            if (urls.length <= 0) {
                urls = [url];
            }

            let images = [];
            urls.map(url => {
                if (url.indexOf("http") == -1) {
                    url = resourceUrl + url;
                }
                images.push(url);
            })
            ImagePreview(images);
        },
    },
};
</script>

<style lang="less" scoped>
.van-cell__title,
.van-cell-group__title {
    text-align: left;
}
.van-panel {
    margin-top: 10px;
}
.van-tag {
    margin-left: 5px;
}

.illegalInfo {
    background-color: #f0f0f0;
    padding-bottom: 70px;
    .panelTitle {
        font-size: 16px;
        padding: 10px;
        text-align: left;
        line-height: 100%;
        border-bottom: 1px solid #fafafa;
        margin-left: 5px;
        display: flex;
        align-items: center;
        div {
            width: 5px;
            height: 20px;
            margin-right: 10px;
            background: #2f54eb;
        }
    }
    .van-panel__content {
        .van-cell__title {
            text-align: left;
        }
        .eachSeekImg {
            width: 50px;
            height: 40px;
        }
        .img {
            width: 50px;
            height: 40px;
        }
    }
    .lawPanel {
        .van-cell {
            border-bottom: 1px solid #f0f0f0;
        }
    }
}
.location-icon {
    color: #1989fa;
    font-size: 20px;
    margin-left: 5px;
}
.float-nav-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 16px;
    background: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
}
</style>
